import React, { useEffect, useRef, useState } from 'react';
import { formatearMoneda, limpiarMoneda } from '../utils/formatMoney';
import './SimuladorResponsive.css';

const API = '/api';
const BANCOS = ['Afirme', 'Banorte', 'Banamex', 'Banregio', 'HSBC', 'Santander', 'Scotiabank'];
const ANIOS_PLAZO = [...Array.from({ length: 20 }, (_, i) => i + 1), 25];
const TIPOS_INMUEBLE = [
  { value: 'adquisicion_vivienda', label: 'Adquisición de Vivienda' },
  { value: 'adquisicion_terreno', label: 'Adquisición de Terreno' },
  { value: 'mejora_hipoteca', label: 'Mejora de Hipoteca' },
  { value: 'liquidez', label: 'Liquidez' },
  { value: 'remodelacion', label: 'Remodelación' },
];
const ESQUEMAS_PAGO = [
  { value: 'fijo', label: 'Fijo' },
  { value: 'creciente', label: 'Creciente' },
];
const esquemaDe = (t) => (t.metodo_calculo === 'pago_creciente' ? 'creciente' : 'fijo');

// Mismo patrón visual/estructural que el filtro de Status del listado de
// Hipotecas del CRM (SeguimientoClientes.jsx) y los DropdownCheckbox de
// ReportesCrmHome.jsx: un botón que resume la selección y despliega un menú
// de checkboxes (selección múltiple) al hacer clic.
function DropdownCheckbox({ label, opciones, seleccion, onToggle, onClear, todosLabel = 'Todos', ancho = 190 }) {
  const [open, setOpen] = useState(false);
  const resumen = seleccion.length === 0
    ? todosLabel
    : seleccion.length === 1
      ? (opciones.find((o) => o.v === seleccion[0])?.l ?? String(seleccion[0]))
      : `${seleccion.length} seleccionados`;
  return (
    <div style={st.filtroField}>
      <label style={st.filtroLabel}>{label}</label>
      <div style={st.dropdownBox}>
        <button type="button" style={{ ...st.dropdownBtn, width: ancho }} onClick={() => setOpen((o) => !o)}>
          <span>{resumen}</span>
          <span style={{ color: '#6b7280' }}>▾</span>
        </button>
        {open && (
          <>
            <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 39 }} />
            <div style={{ ...st.dropdownMenu, minWidth: ancho }}>
              <label style={st.dropdownItem}>
                <input type="checkbox" checked={seleccion.length === 0} onChange={onClear} />
                <strong>{todosLabel}</strong>
              </label>
              <div style={st.dropdownDivider} />
              {opciones.map((o) => (
                <label key={o.v} style={st.dropdownItem}>
                  <input type="checkbox" checked={seleccion.includes(o.v)} onChange={() => onToggle(o.v)} />
                  {o.l}
                </label>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const st = {
  wrap: { padding: 20 },
  headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 8 },
  title: { fontSize: 18, fontWeight: 'bold', color: '#1a3a6e', margin: 0 },
  btnPrimary: { padding: '8px 16px', backgroundColor: '#1a3a6e', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13.5, fontWeight: '600' },
  btnSecondary: { padding: '7px 14px', backgroundColor: 'white', color: '#1a3a6e', border: '1px solid #1a3a6e', borderRadius: 6, cursor: 'pointer', fontSize: 12.5, fontWeight: '600' },
  btnDanger: { padding: '7px 14px', backgroundColor: 'white', color: '#dc2626', border: '1px solid #dc2626', borderRadius: 6, cursor: 'pointer', fontSize: 12.5, fontWeight: '600' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { textAlign: 'left', padding: '8px 10px', backgroundColor: '#1a3a6e', color: 'white', fontWeight: '600', fontSize: 12.5 },
  td: { padding: '8px 10px', borderBottom: '1px solid #e5e7eb', color: '#111827' },
  card: { backgroundColor: '#F9FAFB', border: '1px solid #e5e7eb', borderRadius: 8, padding: 24, marginBottom: 16 },
  grid3: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12, marginBottom: 12 },
  section: { marginBottom: 22, paddingBottom: 22, borderBottom: '1px solid #e5e7eb' },
  sectionLast: { marginBottom: 22 },
  sectionTitle: { fontSize: 13, fontWeight: '700', color: '#1a3a6e', margin: '0 0 12px 0', textTransform: 'uppercase', letterSpacing: 0.3 },
  field: { marginBottom: 4 },
  label: { display: 'block', fontSize: 12, fontWeight: '600', color: '#6b7280', marginBottom: 4 },
  textarea: { width: '100%', padding: '6px 8px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box', fontFamily: 'inherit', resize: 'vertical' },
  input: { width: '100%', height: 36, padding: '6px 8px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' },
  select: { width: '100%', height: 36, padding: '6px 8px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' },
  checkLabel: { fontSize: 13, display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' },
  checkboxGrid: { display: 'flex', flexWrap: 'wrap', gap: 12 },
  filtrosRow: { display: 'flex', gap: 18, flexWrap: 'wrap' },
  filtroField: { display: 'flex', flexDirection: 'column', gap: 6 },
  filtroLabel: { fontSize: 11, fontWeight: 'bold', color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.4 },
  dropdownBox: { position: 'relative' },
  dropdownBtn: { padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, backgroundColor: 'white', cursor: 'pointer', textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 },
  dropdownMenu: { position: 'absolute', top: '100%', left: 0, marginTop: 4, backgroundColor: 'white', border: '1px solid #d1d5db', borderRadius: 6, boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 40, maxHeight: 320, overflowY: 'auto', padding: 6 },
  dropdownItem: { display: 'flex', alignItems: 'center', gap: 8, padding: '6px 8px', fontSize: 13, cursor: 'pointer', borderRadius: 4, whiteSpace: 'nowrap' },
  dropdownDivider: { borderTop: '1px solid #e5e7eb', margin: '4px 0' },
  plazosToolbar: { display: 'flex', gap: 8, marginBottom: 10 },
  btnTiny: { padding: '5px 12px', backgroundColor: 'white', color: '#1a3a6e', border: '1px solid #d1d5db', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: '600' },
  radioLabel: { fontSize: 13, display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', marginRight: 20 },
  rangoRow: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr auto', gap: 8, marginBottom: 6, alignItems: 'center' },
  secCreciente: { gridColumn: '1 / -1', marginLeft: 24, marginBottom: 14, padding: '10px 12px', backgroundColor: 'white', border: '1px solid #e5e7eb', borderLeft: '3px solid #1a3a6e', borderRadius: 6 },
  secCrecienteTitulo: { fontSize: 12, fontWeight: '700', color: '#1a3a6e', marginBottom: 8 },
  secCrecienteNota: { fontSize: 12, color: '#6b7280' },
  secCrecienteFalta: { fontSize: 12, color: '#b45309', margin: '-2px 0 8px 0' },
  inputFalta: { borderColor: '#f59e0b', backgroundColor: '#fffbeb' },
  actions: { display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 },
  error: { color: '#dc2626', fontSize: 12.5, marginTop: 8 },
  empty: { color: '#6b7280', fontSize: 13, padding: 20, textAlign: 'center' },
};

const FORM_VACIO = {
  banco: BANCOS[0],
  tipo_credito: '',
  aplica_tipo_inmueble: 'adquisicion_vivienda',
  tasa_anual: '',
  aplica_iva_intereses: false,
  seguro_vida_anual_pct: '',
  seguro_danos_anual_pct: '',
  costo_admin_mensual: '',
  monto_minimo_costo_admin: '',
  costo_admin_mensual_bajo_minimo: '',
  seguro_desempleo_contenidos_pct: '',
  aplica_seguro_desempleo_contenidos: false,
  aplica_iva_comision_admon_seguros: false,
  comision_apertura_pct: '',
  comision_apertura_pct_apoyo_infonavit: '',
  gastos_spei_cheque_caja: '',
  gastos_investigacion: '',
  metodo_avaluo: 'porcentaje',
  avaluo_pct: '',
  aplica_iva_avaluo: false,
  avaluo_tramos_tarifa_directa: false,
  activo: true,
  rangos: [],
  avaluo_tramos_millar: [],
  plazos_permitidos_meses: [],
  ajustes: [],
  dias_mes_calculo: 30.4,
  factores: [],
  aforo_maximo_pct: '',
  monto_maximo_credito: '',
  aforo_rangos: [],
  secundarias: [],
  condicionante: '',
  condicionante_tasa_base: '',
  tasa_por_plazo_activo: false,
  plazo_tasa_rangos: [],
  esquema_pago: 'fijo',
  pago_creciente_plazos: [],
};

const SimuladorTasasCatalogo = () => {
  const [tasas, setTasas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [editId, setEditId] = useState(null); // null = ninguno, 'nuevo' = alta, id = edición
  const [form, setForm] = useState(FORM_VACIO);
  const [error, setError] = useState('');
  const [guardando, setGuardando] = useState(false);

  const [filtroBancos, setFiltroBancos] = useState([]);
  const [filtroTipos, setFiltroTipos] = useState([]);
  const [filtroEsquemas, setFiltroEsquemas] = useState([]);
  const toggleFiltro = (setter) => (valor) => {
    setter((actuales) => (actuales.includes(valor) ? actuales.filter((v) => v !== valor) : [...actuales, valor]));
  };
  const toggleFiltroBanco = toggleFiltro(setFiltroBancos);
  const toggleFiltroTipo = toggleFiltro(setFiltroTipos);
  const toggleFiltroEsquema = toggleFiltro(setFiltroEsquemas);

  const [apoyoInfonavitAbierto, setApoyoInfonavitAbierto] = useState(false);
  const [apoyoInfonavitForm, setApoyoInfonavitForm] = useState({ pct_sueldo_mensual: '', tope_bimestral: '' });
  const [apoyoInfonavitError, setApoyoInfonavitError] = useState('');
  const [apoyoInfonavitGuardando, setApoyoInfonavitGuardando] = useState(false);

  // Mide el alto real del encabezado "Tasas y Condiciones por Banco" para que
  // el thead de la tabla se pegue justo debajo (mismo patrón que
  // --app-header-h en App.js / ReportesCrmHome.jsx).
  const headerRowRef = useRef(null);
  const [headerRowH, setHeaderRowH] = useState(56);
  useEffect(() => {
    const el = headerRowRef.current;
    if (!el) return;
    const medir = () => setHeaderRowH(el.offsetHeight);
    medir();
    const ro = new ResizeObserver(medir);
    ro.observe(el);
    window.addEventListener('resize', medir);
    return () => { ro.disconnect(); window.removeEventListener('resize', medir); };
  }, []);

  const cargar = () => {
    setCargando(true);
    fetch(`${API}/simulador/tasas`)
      .then((r) => r.json())
      .then((data) => setTasas(Array.isArray(data) ? data : []))
      .finally(() => setCargando(false));
  };

  useEffect(() => { cargar(); }, []);

  const abrirApoyoInfonavit = () => {
    setApoyoInfonavitError('');
    fetch(`${API}/simulador/apoyo-infonavit-config`)
      .then((r) => r.json())
      .then((data) => setApoyoInfonavitForm({
        pct_sueldo_mensual: data?.pct_sueldo_mensual ?? '',
        tope_bimestral: data?.tope_bimestral ?? '',
      }));
    setApoyoInfonavitAbierto(true);
  };
  const cerrarApoyoInfonavit = () => { setApoyoInfonavitAbierto(false); setApoyoInfonavitError(''); };
  const guardarApoyoInfonavit = async () => {
    setApoyoInfonavitGuardando(true);
    setApoyoInfonavitError('');
    try {
      const r = await fetch(`${API}/simulador/apoyo-infonavit-config`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(apoyoInfonavitForm),
      });
      const data = await r.json();
      if (!r.ok) { setApoyoInfonavitError(data.error || 'Error al guardar'); return; }
      setApoyoInfonavitAbierto(false);
    } catch (e) {
      setApoyoInfonavitError('No se pudo conectar con el servidor. Intenta de nuevo.');
    } finally {
      setApoyoInfonavitGuardando(false);
    }
  };

  const abrirNuevo = () => { setForm(FORM_VACIO); setEditId('nuevo'); setError(''); };
  const abrirEditar = (t) => {
    setForm({
      banco: t.banco,
      tipo_credito: t.tipo_credito,
      aplica_tipo_inmueble: t.aplica_tipo_inmueble || 'adquisicion_vivienda',
      tasa_anual: t.tasa_anual,
      aplica_iva_intereses: t.aplica_iva_intereses,
      seguro_vida_anual_pct: t.seguro_vida_anual_pct,
      seguro_danos_anual_pct: t.seguro_danos_anual_pct,
      costo_admin_mensual: t.costo_admin_mensual,
      monto_minimo_costo_admin: t.monto_minimo_costo_admin ?? '',
      costo_admin_mensual_bajo_minimo: t.costo_admin_mensual_bajo_minimo ?? '',
      seguro_desempleo_contenidos_pct: t.seguro_desempleo_contenidos_pct,
      aplica_seguro_desempleo_contenidos: !!t.aplica_seguro_desempleo_contenidos,
      aplica_iva_comision_admon_seguros: t.aplica_iva_comision_admon_seguros,
      comision_apertura_pct: t.comision_apertura_pct,
      comision_apertura_pct_apoyo_infonavit: t.comision_apertura_pct_apoyo_infonavit ?? '',
      gastos_spei_cheque_caja: t.gastos_spei_cheque_caja ?? '',
      gastos_investigacion: t.gastos_investigacion ?? '',
      metodo_avaluo: t.metodo_avaluo,
      avaluo_pct: t.avaluo_pct ?? '',
      aplica_iva_avaluo: !!t.aplica_iva_avaluo,
      avaluo_tramos_tarifa_directa: !!t.avaluo_tramos_tarifa_directa,
      activo: t.activo,
      rangos: (t.rangos || []).map((r) => ({
        valor_minimo: r.valor_minimo, valor_maximo: r.valor_maximo, monto_fijo: r.monto_fijo,
        // Migración 121: excedente opcional (vacío = monto fijo). Se carga y se reenvía
        // para que guardar el formulario (borra y recrea rangos) no lo pierda.
        excedente_sobre: r.excedente_sobre ?? '', monto_por_millon_excedente: r.monto_por_millon_excedente ?? '',
      })),
      avaluo_tramos_millar: (t.avaluo_tramos_millar || []).map((tr) => ({
        valor_minimo: tr.valor_minimo, valor_maximo: tr.valor_maximo,
        tarifa_al_millar: tr.tarifa_al_millar ?? '', costo_no_menor: tr.costo_no_menor ?? '',
      })),
      plazos_permitidos_meses: t.plazos_permitidos_meses || [],
      ajustes: (t.ajustes || []).map((a) => ({ mes_desde: a.mes_desde, ajuste_pct: a.ajuste_pct })),
      dias_mes_calculo: t.dias_mes_calculo != null ? String(Number(t.dias_mes_calculo)) : '30.4',
      factores: (t.factores || []).map((f) => ({ plazo_meses: f.plazo_meses, factor_pct: f.factor_pct })),
      aforo_maximo_pct: t.aforo_maximo_pct ?? '',
      monto_maximo_credito: t.monto_maximo_credito ?? '',
      aforo_rangos: (t.aforo_rangos || []).map((a) => ({ aforo_minimo: a.aforo_minimo, aforo_maximo: a.aforo_maximo, tasa_anual: a.tasa_anual })),
      // El id se conserva para que el backend actualice la secundaria en vez de
      // borrarla y recrearla (perdía sus renglones de Pago Creciente).
      // plazos_creciente: sus renglones propios de Pago Creciente, por
      // plazo_meses (mismas unidades que los de la tasa base).
      secundarias: (t.secundarias || []).map((s) => ({
        id: s.id, etiqueta: s.etiqueta, tasa_pct: s.tasa_pct,
        aforo_minimo: s.aforo_minimo ?? '', aforo_maximo: s.aforo_maximo ?? '',
        condicionante: s.condicionante ?? '',
        plazos_creciente: Object.fromEntries((t.pago_creciente_plazos || [])
          .filter((p) => p.tasa_secundaria_id != null && Number(p.tasa_secundaria_id) === Number(s.id))
          .map((p) => [Number(p.plazo_meses), {
            incremento_anual_pct: p.incremento_anual_pct,
            // pago_inicial_pct trae 6 decimales = centavos exactos por millón;
            // se redondea para no mostrar residuos de punto flotante (8,811.130000000001).
            pago_inicial: p.pago_inicial_pct != null ? Math.round(Number(p.pago_inicial_pct) * 1000000) / 100 : '',
          }])),
      })),
      condicionante: t.condicionante ?? '',
      condicionante_tasa_base: t.condicionante_tasa_base ?? '',
      tasa_por_plazo_activo: !!t.tasa_por_plazo_activo,
      plazo_tasa_rangos: (t.plazo_tasa_rangos || []).map((p) => ({ plazo_minimo_anios: p.plazo_minimo_anios, plazo_maximo_anios: p.plazo_maximo_anios, tasa_pct: p.tasa_pct })),
      esquema_pago: t.metodo_calculo === 'pago_creciente' ? 'creciente' : 'fijo',
      // Solo los renglones de la tasa primaria: los de tasa secundaria
      // (tasa_secundaria_id) no se capturan aquí y el backend los conserva; si
      // se cargaban al formulario se reenviaban como primarios y el guardado
      // fallaba por plazo duplicado.
      pago_creciente_plazos: (t.pago_creciente_plazos || []).filter((p) => p.tasa_secundaria_id == null).map((p) => ({
        plazo_anios: p.plazo_meses ? p.plazo_meses / 12 : '',
        incremento_anual_pct: p.incremento_anual_pct,
        // Se captura como peso equivalente a un crédito de $1,000,000 (tal cual lo
        // publica el banco); se guarda como % del crédito (pago_inicial_pct).
        pago_inicial: p.pago_inicial_pct != null ? Number(p.pago_inicial_pct) / 100 * 1000000 : '',
      })),
    });
    setEditId(t.id);
    setError('');
  };
  const cancelar = () => { setEditId(null); setForm(FORM_VACIO); setError(''); };

  const upd = (patch) => setForm((f) => ({ ...f, ...patch }));

  const agregarRango = () => upd({ rangos: [...form.rangos, { valor_minimo: '', valor_maximo: '', monto_fijo: '', excedente_sobre: '', monto_por_millon_excedente: '' }] });
  const quitarRango = (i) => upd({ rangos: form.rangos.filter((_, idx) => idx !== i) });
  const cambiarRango = (i, patch) => upd({ rangos: form.rangos.map((r, idx) => (idx === i ? { ...r, ...patch } : r)) });

  const agregarTramoMillar = () => upd({ avaluo_tramos_millar: [...form.avaluo_tramos_millar, { valor_minimo: '', valor_maximo: '', tarifa_al_millar: '', costo_no_menor: '' }] });
  const quitarTramoMillar = (i) => upd({ avaluo_tramos_millar: form.avaluo_tramos_millar.filter((_, idx) => idx !== i) });
  const cambiarTramoMillar = (i, patch) => upd({ avaluo_tramos_millar: form.avaluo_tramos_millar.map((t, idx) => (idx === i ? { ...t, ...patch } : t)) });

  const toggleAnioPlazo = (anio) => {
    const meses = anio * 12;
    upd({
      plazos_permitidos_meses: form.plazos_permitidos_meses.includes(meses)
        ? form.plazos_permitidos_meses.filter((m) => m !== meses)
        : [...form.plazos_permitidos_meses, meses],
    });
  };
  const seleccionarTodosPlazos = () => upd({ plazos_permitidos_meses: ANIOS_PLAZO.map((anio) => anio * 12) });
  const quitarTodosPlazos = () => upd({ plazos_permitidos_meses: [] });

  const agregarAjuste = () => upd({ ajustes: [...form.ajustes, { mes_desde: '', ajuste_pct: '' }] });
  const quitarAjuste = (i) => upd({ ajustes: form.ajustes.filter((_, idx) => idx !== i) });
  const cambiarAjuste = (i, patch) => upd({ ajustes: form.ajustes.map((a, idx) => (idx === i ? { ...a, ...patch } : a)) });

  const agregarFactor = () => upd({ factores: [...form.factores, { plazo_meses: '', factor_pct: '' }] });
  const quitarFactor = (i) => upd({ factores: form.factores.filter((_, idx) => idx !== i) });
  const cambiarFactor = (i, patch) => upd({ factores: form.factores.map((f, idx) => (idx === i ? { ...f, ...patch } : f)) });

  const agregarAforoRango = () => upd({ aforo_rangos: [...form.aforo_rangos, { aforo_minimo: '', aforo_maximo: '', tasa_anual: '' }] });
  const quitarAforoRango = (i) => upd({ aforo_rangos: form.aforo_rangos.filter((_, idx) => idx !== i) });
  const cambiarAforoRango = (i, patch) => upd({ aforo_rangos: form.aforo_rangos.map((a, idx) => (idx === i ? { ...a, ...patch } : a)) });

  const agregarSecundaria = () => upd({ secundarias: [...form.secundarias, { etiqueta: '', tasa_pct: '', aforo_minimo: '', aforo_maximo: '', condicionante: '', plazos_creciente: {} }] });
  const quitarSecundaria = (i) => upd({ secundarias: form.secundarias.filter((_, idx) => idx !== i) });
  const cambiarSecundaria = (i, patch) => upd({ secundarias: form.secundarias.map((s, idx) => (idx === i ? { ...s, ...patch } : s)) });
  const cambiarPlazoSecundaria = (i, meses, patch) => upd({
    secundarias: form.secundarias.map((s, idx) => (idx === i
      ? { ...s, plazos_creciente: { ...(s.plazos_creciente || {}), [meses]: { ...((s.plazos_creciente || {})[meses] || {}), ...patch } } }
      : s)),
  });

  // Plazos de la tasa base (Pago Creciente): cada tasa secundaria lleva un
  // renglón por cada uno, con el incremento prellenado con el de la base.
  const plazosBaseCreciente = () => {
    const vistos = new Set();
    return form.pago_creciente_plazos
      .filter((p) => p.plazo_anios !== '' && Number(p.plazo_anios) > 0)
      .map((p) => ({ meses: Number(p.plazo_anios) * 12, incremento_anual_pct: p.incremento_anual_pct }))
      .filter((p) => (vistos.has(p.meses) ? false : vistos.add(p.meses)));
  };
  const plazoSecundaria = (s, base) => {
    const propio = (s.plazos_creciente || {})[base.meses] || {};
    return {
      incremento_anual_pct: propio.incremento_anual_pct !== undefined ? propio.incremento_anual_pct : base.incremento_anual_pct,
      pago_inicial: propio.pago_inicial ?? '',
    };
  };

  const agregarPlazoTasaRango = () => upd({ plazo_tasa_rangos: [...form.plazo_tasa_rangos, { plazo_minimo_anios: '', plazo_maximo_anios: '', tasa_pct: '' }] });
  const quitarPlazoTasaRango = (i) => upd({ plazo_tasa_rangos: form.plazo_tasa_rangos.filter((_, idx) => idx !== i) });
  const cambiarPlazoTasaRango = (i, patch) => upd({ plazo_tasa_rangos: form.plazo_tasa_rangos.map((p, idx) => (idx === i ? { ...p, ...patch } : p)) });

  const agregarPagoCrecientePlazo = () => upd({ pago_creciente_plazos: [...form.pago_creciente_plazos, { plazo_anios: '', incremento_anual_pct: '', pago_inicial: '' }] });
  const quitarPagoCrecientePlazo = (i) => upd({ pago_creciente_plazos: form.pago_creciente_plazos.filter((_, idx) => idx !== i) });
  const cambiarPagoCrecientePlazo = (i, patch) => upd({ pago_creciente_plazos: form.pago_creciente_plazos.map((p, idx) => (idx === i ? { ...p, ...patch } : p)) });

  const guardar = async () => {
    if (!form.tipo_credito.trim()) { setError('Falta el nombre del tipo de crédito'); return; }
    if (!form.tasa_anual) { setError('Falta la tasa de interés anual'); return; }
    if (form.metodo_avaluo === 'porcentaje' && !form.avaluo_pct) { setError('Falta el % de avalúo'); return; }
    if (form.metodo_avaluo === 'tabla_rangos' && form.rangos.length === 0) { setError('Agrega al menos un rango de avalúo'); return; }
    if (form.metodo_avaluo === 'tabla_rangos' && form.rangos.some((r) => ((r.excedente_sobre ?? '') === '') !== ((r.monto_por_millon_excedente ?? '') === ''))) {
      setError('En los rangos de avalúo, captura "Excedente sobre" y "$ por millón" juntos, o deja los dos vacíos'); return;
    }
    if (form.metodo_avaluo === 'tramos_millar' && form.avaluo_tramos_millar.length === 0) { setError('Agrega al menos un tramo de avalúo'); return; }
    if (form.metodo_avaluo === 'tramos_millar' && form.avaluo_tramos_millar.some((t) => t.valor_minimo === '')) { setError('Completa el Valor mínimo en todos los tramos de avalúo'); return; }
    if (form.aforo_rangos.some((a) => a.aforo_minimo === '' || a.tasa_anual === '')) { setError('Completa % Aforo Mínimo y Tasa Anual en todos los rangos de Aforo, o quítalos'); return; }
    if (form.secundarias.some((s) => !s.etiqueta.trim() || s.tasa_pct === '')) { setError('Completa la etiqueta y la tasa % en todas las Tasas Secundarias, o quítalas'); return; }
    if (form.tasa_por_plazo_activo && form.plazo_tasa_rangos.length === 0) { setError('Agrega al menos un rango de plazo para la Tasa según Plazo Total, o desactiva la opción'); return; }
    if (form.plazo_tasa_rangos.some((p) => p.plazo_minimo_anios === '' || p.tasa_pct === '')) { setError('Completa Plazo Mínimo y Tasa % en todos los rangos de Plazo Total, o quítalos'); return; }
    if (form.esquema_pago === 'creciente' && form.pago_creciente_plazos.length === 0) { setError('Agrega al menos un plazo con su % de Incremento Anual del Pago'); return; }
    if (form.pago_creciente_plazos.some((p) => p.plazo_anios === '' || p.incremento_anual_pct === '')) { setError('Completa Plazo (años) y % Incremento Anual en todos los renglones, o quítalos'); return; }
    if (form.esquema_pago === 'creciente') {
      const faltantes = [];
      form.secundarias.filter((s) => s.etiqueta.trim() && s.tasa_pct !== '').forEach((s) => {
        plazosBaseCreciente().forEach((b) => {
          const p = plazoSecundaria(s, b);
          if (p.pago_inicial === '' || p.incremento_anual_pct === '') faltantes.push(`${s.etiqueta.trim()} (${b.meses / 12} años)`);
        });
      });
      if (faltantes.length && !window.confirm(
        `Falta el Pago Mensual Inicial de estas tasas secundarias:\n\n${faltantes.join('\n')}\n\n`
        + 'Mientras falte, esa tasa no aparece en el comparador en ese plazo. ¿Guardar de todos modos?'
      )) return;
    }

    setGuardando(true);
    setError('');
    try {
      const url = editId === 'nuevo' ? `${API}/simulador/tasas` : `${API}/simulador/tasas/${editId}`;
      const method = editId === 'nuevo' ? 'POST' : 'PUT';
      const body = {
        ...form,
        rangos: form.metodo_avaluo === 'tabla_rangos'
          ? form.rangos.map((r) => ({
            valor_minimo: r.valor_minimo, valor_maximo: r.valor_maximo === '' ? null : r.valor_maximo, monto_fijo: r.monto_fijo,
            excedente_sobre: (r.excedente_sobre ?? '') === '' ? null : r.excedente_sobre,
            monto_por_millon_excedente: (r.monto_por_millon_excedente ?? '') === '' ? null : r.monto_por_millon_excedente,
          }))
          : [],
        avaluo_tramos_millar: form.metodo_avaluo === 'tramos_millar'
          ? form.avaluo_tramos_millar.map((t) => ({
            valor_minimo: t.valor_minimo,
            valor_maximo: t.valor_maximo === '' ? null : t.valor_maximo,
            tarifa_al_millar: t.tarifa_al_millar === '' ? null : t.tarifa_al_millar,
            costo_no_menor: t.costo_no_menor === '' ? null : t.costo_no_menor,
          }))
          : [],
        ajustes: form.ajustes.filter((a) => a.mes_desde !== '' && a.ajuste_pct !== ''),
        factores: form.factores.filter((f) => f.plazo_meses !== '' && f.factor_pct !== ''),
        aforo_maximo_pct: form.aforo_maximo_pct === '' ? null : form.aforo_maximo_pct,
        monto_maximo_credito: form.monto_maximo_credito === '' ? null : form.monto_maximo_credito,
        aforo_rangos: form.aforo_rangos
          .filter((a) => a.aforo_minimo !== '' && a.tasa_anual !== '')
          .map((a) => ({ aforo_minimo: a.aforo_minimo, aforo_maximo: a.aforo_maximo === '' ? null : a.aforo_maximo, tasa_anual: a.tasa_anual })),
        secundarias: form.secundarias
          .filter((s) => s.etiqueta.trim() !== '' && s.tasa_pct !== '')
          .map((s) => ({
            id: s.id || undefined, etiqueta: s.etiqueta, tasa_pct: s.tasa_pct,
            aforo_minimo: s.aforo_minimo === '' ? null : s.aforo_minimo,
            aforo_maximo: s.aforo_maximo === '' ? null : s.aforo_maximo,
            condicionante: s.condicionante || null,
            // Un renglón por plazo de la tasa base; sin Pago Inicial el backend
            // no lo guarda (y borra el que hubiera).
            ...(form.esquema_pago === 'creciente' ? {
              pago_creciente_plazos: plazosBaseCreciente().map((b) => {
                const p = plazoSecundaria(s, b);
                return {
                  plazo_meses: b.meses,
                  incremento_anual_pct: p.incremento_anual_pct,
                  pago_inicial_pct: p.pago_inicial === '' ? null : Number(p.pago_inicial) / 1000000 * 100,
                };
              }),
            } : {}),
          })),
        condicionante: form.condicionante || null,
        condicionante_tasa_base: form.condicionante_tasa_base || null,
        plazo_tasa_rangos: form.plazo_tasa_rangos
          .filter((p) => p.plazo_minimo_anios !== '' && p.tasa_pct !== '')
          .map((p) => ({ plazo_minimo_anios: p.plazo_minimo_anios, plazo_maximo_anios: p.plazo_maximo_anios === '' ? null : p.plazo_maximo_anios, tasa_pct: p.tasa_pct })),
        pago_creciente_plazos: form.esquema_pago === 'creciente'
          ? form.pago_creciente_plazos
            .filter((p) => p.plazo_anios !== '' && p.incremento_anual_pct !== '')
            .map((p) => ({
              plazo_meses: Number(p.plazo_anios) * 12,
              incremento_anual_pct: p.incremento_anual_pct,
              pago_inicial_pct: p.pago_inicial === '' ? null : Number(p.pago_inicial) / 1000000 * 100,
            }))
          : [],
      };
      const r = await fetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      if (!r.ok) {
        const d = await r.json().catch(() => ({}));
        setError(d.error || 'Error al guardar');
        return;
      }
      cancelar();
      cargar();
    } catch (e) {
      setError('No se pudo conectar con el servidor. Intenta de nuevo.');
    } finally {
      setGuardando(false);
    }
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar este renglón del catálogo? Esta acción no se puede deshacer.')) return;
    await fetch(`${API}/simulador/tasas/${id}`, { method: 'DELETE' });
    cargar();
  };

  const renderForm = () => (
    <div style={st.card} className="sim-card">
      <div style={st.section}>
        <h4 style={st.sectionTitle}>Datos generales</h4>
        <div style={st.grid3}>
          <div style={st.field}>
            <label style={st.label}>Banco</label>
            <select style={st.select} value={form.banco} onChange={(e) => upd({ banco: e.target.value })}>
              {BANCOS.map((b) => <option key={b} value={b}>{b}</option>)}
            </select>
          </div>
          <div style={st.field}>
            <label style={st.label}>Nombre de Hipoteca</label>
            <input style={st.input} value={form.tipo_credito} onChange={(e) => upd({ tipo_credito: e.target.value })} placeholder="Ej. Tradicional" />
          </div>
          <div style={st.field}>
            <label style={st.label}>Tipo de Hipoteca</label>
            <select style={st.select} value={form.aplica_tipo_inmueble} onChange={(e) => upd({ aplica_tipo_inmueble: e.target.value })}>
              {TIPOS_INMUEBLE.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
          </div>
          <div style={st.field}>
            <label style={st.checkLabel}>
              <input type="checkbox" checked={!!form.activo} onChange={(e) => upd({ activo: e.target.checked })} />
              Activo (disponible en el comparador)
            </label>
          </div>
          <div style={st.field}>
            <label style={st.label}>Esquema de Pago</label>
            <select style={st.select} value={form.esquema_pago} onChange={(e) => upd({ esquema_pago: e.target.value })}>
              <option value="fijo">Fijo</option>
              <option value="creciente">Creciente</option>
            </select>
          </div>
        </div>
      </div>

      {form.esquema_pago === 'creciente' && (
        <div style={st.section}>
          <h4 style={st.sectionTitle}>Plazos y % de Incremento Anual del Pago</h4>
          <label style={st.label}>
            El pago sube este % cada 12 meses. Estos son los únicos plazos que el comparador ofrecerá para este registro.
            Si el crédito también tiene Escalones de reducción de tasa (más abajo), captura el Pago Mensual Inicial que
            publica el banco tal cual aparece en su tabla (para un crédito de $1,000,000) — el sistema lo escala
            automáticamente al monto real del crédito. No se puede calcular automáticamente en ese caso. Si no tiene
            escalones, déjalo vacío.
          </label>
          <div className="sim-rango-scroll">
          <div style={{ minWidth: 620 }}>
          {form.pago_creciente_plazos.length > 0 && (
            <div style={{ ...st.rangoRow, gridTemplateColumns: '1fr 1fr 1fr auto', fontWeight: '600', color: '#6b7280', fontSize: 12 }}>
              <div>Plazo (años)</div><div>% Incremento Anual</div><div>Pago Mensual Inicial por c/$1,000,000 de crédito (opcional)</div><div></div>
            </div>
          )}
          {form.pago_creciente_plazos.map((p, i) => (
            <div style={{ ...st.rangoRow, gridTemplateColumns: '1fr 1fr 1fr auto' }} key={i}>
              <input type="number" step="1" min="1" style={st.input} value={p.plazo_anios} onChange={(e) => cambiarPagoCrecientePlazo(i, { plazo_anios: e.target.value })} placeholder="Ej. 20" />
              <input type="number" step="0.01" min="0" max="99.99" style={st.input} value={p.incremento_anual_pct} onChange={(e) => cambiarPagoCrecientePlazo(i, { incremento_anual_pct: e.target.value })} placeholder="Ej. 1.45" />
              <input style={st.input} value={formatearMoneda(p.pago_inicial, 2)} onChange={(e) => cambiarPagoCrecientePlazo(i, { pago_inicial: limpiarMoneda(e.target.value, 2) })} placeholder="Automático" />
              <button type="button" style={st.btnDanger} onClick={() => quitarPagoCrecientePlazo(i)}>Quitar</button>
            </div>
          ))}
          </div>
          </div>
          <button type="button" style={st.btnSecondary} onClick={agregarPagoCrecientePlazo}>+ Agregar plazo</button>
        </div>
      )}

      <div style={st.section}>
        <h4 style={st.sectionTitle}>Tasa y cálculo</h4>
        <div style={st.grid3}>
          <div style={st.field}>
            <label style={st.label}>Tasa de interés anual (%)</label>
            <input type="number" step="0.01" min="0" max="99.99" style={st.input} value={form.tasa_anual} onChange={(e) => upd({ tasa_anual: e.target.value })} placeholder="Ej. 12.34" />
          </div>
          <div style={st.field}>
            <label style={st.label}>Base de días para tasa mensual</label>
            <select style={st.select} value={form.dias_mes_calculo} onChange={(e) => upd({ dias_mes_calculo: e.target.value })}>
              <option value="30.4">30.4 / 360 (Banorte y estándar)</option>
              <option value="30.41667">365/12 / 360 (Santander)</option>
              <option value="30">30 / 360 (Banamex)</option>
            </select>
          </div>
          <div style={st.field}>
            <label style={st.label}>% Máximo de Crédito a Otorgar (Aforo máximo)</label>
            <input type="number" step="1" min="0" max="99" style={st.input} value={form.aforo_maximo_pct} onChange={(e) => upd({ aforo_maximo_pct: e.target.value })} placeholder="Ej. 80, vacío = sin límite" />
          </div>
          <div style={st.field}>
            <label style={st.label}>Monto Máximo de Crédito a Otorgar ($)</label>
            <input style={st.input} value={formatearMoneda(form.monto_maximo_credito, 2)} onChange={(e) => upd({ monto_maximo_credito: limpiarMoneda(e.target.value, 2) })} placeholder="Vacío = sin límite en $" />
          </div>
          <div style={st.field}>
            <label style={st.checkLabel}>
              <input type="checkbox" checked={!!form.aplica_iva_intereses} onChange={(e) => upd({ aplica_iva_intereses: e.target.checked })} />
              ¿Aplica IVA (16%) sobre intereses?
            </label>
          </div>
        </div>
      </div>

      <div style={st.section}>
        <h4 style={st.sectionTitle}>Seguros y comisiones</h4>
        <div style={st.grid3}>
          <div style={st.field}>
            <label style={st.label}>Seguro de vida mensual (% sobre saldo insoluto)</label>
            <input type="number" step="0.00000001" style={st.input} value={form.seguro_vida_anual_pct} onChange={(e) => upd({ seguro_vida_anual_pct: e.target.value })} />
          </div>
          <div style={st.field}>
            <label style={st.label}>Seguro de daños mensual (% sobre valor propiedad)</label>
            <input type="number" step="0.00000001" style={st.input} value={form.seguro_danos_anual_pct} onChange={(e) => upd({ seguro_danos_anual_pct: e.target.value })} />
          </div>
          <div style={st.field}>
            <label style={st.label}>Seguro de Desempleo y Contenidos mensual (% sobre monto crédito)</label>
            <input type="number" step="0.00000001" style={st.input} value={form.seguro_desempleo_contenidos_pct} onChange={(e) => upd({ seguro_desempleo_contenidos_pct: e.target.value })} placeholder="0 si no aplica" />
            <label style={{ ...st.checkLabel, marginTop: 6 }}>
              <input type="checkbox" checked={!!form.aplica_seguro_desempleo_contenidos} onChange={(e) => upd({ aplica_seguro_desempleo_contenidos: e.target.checked })} />
              Afirme: calcular con fórmula fija por plazo (Adquisición de Vivienda, Mejora de Hipoteca o Adquisición de Terreno, según destino)
            </label>
          </div>
          <div style={st.field}>
            <label style={st.label}>Costo administrativo mensual ($)</label>
            <input style={st.input} value={formatearMoneda(form.costo_admin_mensual, 2)} onChange={(e) => upd({ costo_admin_mensual: limpiarMoneda(e.target.value, 2) })} />
          </div>
          <div style={st.field}>
            <label style={st.label}>Monto mínimo de crédito para el costo administrativo de arriba ($)</label>
            <input style={st.input} value={formatearMoneda(form.monto_minimo_costo_admin, 2)} onChange={(e) => upd({ monto_minimo_costo_admin: limpiarMoneda(e.target.value, 2) })} placeholder="Vacío = sin umbral, siempre aplica el de arriba" />
          </div>
          <div style={st.field}>
            <label style={st.label}>Costo administrativo mensual por debajo del mínimo ($)</label>
            <input style={st.input} value={formatearMoneda(form.costo_admin_mensual_bajo_minimo, 2)} onChange={(e) => upd({ costo_admin_mensual_bajo_minimo: limpiarMoneda(e.target.value, 2) })} placeholder="Solo si capturaste el monto mínimo" />
          </div>
          <div style={st.field}>
            <label style={st.label}>Comisión de apertura (% sobre monto crédito)</label>
            <input type="number" step="0.01" min="0" max="9.99" style={st.input} value={form.comision_apertura_pct} onChange={(e) => upd({ comision_apertura_pct: e.target.value })} placeholder="Ej. 1.50, 0 si no aplica" />
          </div>
          <div style={st.field}>
            <label style={st.label}>Comisión de apertura con Apoyo Infonavit (%)</label>
            <input type="number" step="0.01" min="0" max="9.99" style={st.input} value={form.comision_apertura_pct_apoyo_infonavit} onChange={(e) => upd({ comision_apertura_pct_apoyo_infonavit: e.target.value })} placeholder="Vacío = sin cambio, siempre aplica la de arriba" />
          </div>
          <div style={st.field}>
            <label style={st.label}>Gastos SPEI/Cheque Caja ($)</label>
            <input style={st.input} value={formatearMoneda(form.gastos_spei_cheque_caja, 2)} onChange={(e) => upd({ gastos_spei_cheque_caja: limpiarMoneda(e.target.value, 2) })} placeholder="0 si no aplica" />
          </div>
          {form.banco === 'Banorte' && (
            <div style={st.field}>
              <label style={st.label}>Gastos de Investigación ($, solo Banorte)</label>
              <input style={st.input} value={formatearMoneda(form.gastos_investigacion, 2)} onChange={(e) => upd({ gastos_investigacion: limpiarMoneda(e.target.value, 2) })} placeholder="0 si no aplica" />
            </div>
          )}
          <div style={st.field}>
            <label style={st.checkLabel}>
              <input type="checkbox" checked={!!form.aplica_iva_comision_admon_seguros} onChange={(e) => upd({ aplica_iva_comision_admon_seguros: e.target.checked })} />
              ¿Aplica IVA (16%) sobre Comisión de Admón. y Seguros?
            </label>
          </div>
        </div>
      </div>

      <div style={st.section}>
        <h4 style={st.sectionTitle}>Método de cálculo del gasto de avalúo</h4>
        <div style={{ marginBottom: 10 }}>
          <label style={st.radioLabel}>
            <input type="radio" checked={form.metodo_avaluo === 'porcentaje'} onChange={() => upd({ metodo_avaluo: 'porcentaje' })} />
            Porcentaje
          </label>
          <label style={st.radioLabel}>
            <input type="radio" checked={form.metodo_avaluo === 'tabla_rangos'} onChange={() => upd({ metodo_avaluo: 'tabla_rangos' })} />
            Tabla de rangos
          </label>
          <label style={st.radioLabel}>
            <input type="radio" checked={form.metodo_avaluo === 'tramos_millar'} onChange={() => upd({ metodo_avaluo: 'tramos_millar' })} />
            Tramos + tarifa
          </label>
        </div>

        {form.metodo_avaluo === 'porcentaje' ? (
          <div style={{ maxWidth: 220 }}>
            <label style={st.label}>% sobre valor de la propiedad</label>
            <input type="number" step="0.0001" min="0" max="9.9999" style={st.input} value={form.avaluo_pct} onChange={(e) => upd({ avaluo_pct: e.target.value })} placeholder="Ej. 0.4060" />
          </div>
        ) : form.metodo_avaluo === 'tabla_rangos' ? (
          <div>
            <div className="sim-rango-scroll">
            <label style={st.label}>
              Opcional por rango: "Excedente sobre" y "$ por millón" — el costo será Monto fijo + $ por millón × (Valor − Excedente sobre) / 1,000,000 (prorrateado).
              Déjalos vacíos para cobrar solo el Monto fijo.
            </label>
            <div style={{ minWidth: 900 }}>
            <div style={{ ...st.rangoRow, gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr auto', fontWeight: '600', color: '#6b7280', fontSize: 12 }}>
              <div>Valor mínimo</div><div>Valor máximo (vacío = sin tope)</div><div>Monto fijo</div><div>Excedente sobre (opcional)</div><div>$ por millón (opcional)</div><div></div>
            </div>
            {form.rangos.map((r, i) => (
              <div style={{ ...st.rangoRow, gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr auto' }} key={i}>
                <input style={st.input} value={formatearMoneda(r.valor_minimo, 2)} onChange={(e) => cambiarRango(i, { valor_minimo: limpiarMoneda(e.target.value, 2) })} />
                <input style={st.input} value={formatearMoneda(r.valor_maximo, 2)} onChange={(e) => cambiarRango(i, { valor_maximo: limpiarMoneda(e.target.value, 2) })} placeholder="sin tope" />
                <input style={st.input} value={formatearMoneda(r.monto_fijo, 2)} onChange={(e) => cambiarRango(i, { monto_fijo: limpiarMoneda(e.target.value, 2) })} />
                <input style={st.input} value={formatearMoneda(r.excedente_sobre, 2)} onChange={(e) => cambiarRango(i, { excedente_sobre: limpiarMoneda(e.target.value, 2) })} placeholder="—" />
                <input style={st.input} value={formatearMoneda(r.monto_por_millon_excedente, 2)} onChange={(e) => cambiarRango(i, { monto_por_millon_excedente: limpiarMoneda(e.target.value, 2) })} placeholder="—" />
                <button type="button" style={st.btnDanger} onClick={() => quitarRango(i)}>Quitar</button>
              </div>
            ))}
            </div>
            </div>
            <button type="button" style={st.btnSecondary} onClick={agregarRango}>+ Agregar rango</button>
          </div>
        ) : (
          <div>
            <div style={{ marginBottom: 10 }}>
              <label style={st.radioLabel}>
                <input type="radio" checked={!form.avaluo_tramos_tarifa_directa} onChange={() => upd({ avaluo_tramos_tarifa_directa: false })} />
                Tarifa al millar (se divide entre 1000, ej. Afirme)
              </label>
              <label style={st.radioLabel}>
                <input type="radio" checked={!!form.avaluo_tramos_tarifa_directa} onChange={() => upd({ avaluo_tramos_tarifa_directa: true })} />
                Tarifa directa (multiplicador decimal, ej. Banregio)
              </label>
            </div>
            <label style={st.label}>
              Costo = máximo entre (Valor del inmueble × Tarifa{form.avaluo_tramos_tarifa_directa ? '' : ' / 1000'}) y el Costo No Menor de ese tramo — no se suman.
              Deja Tarifa y Costo No Menor vacíos en un tramo para marcarlo como "Se Cotiza" (ej. el último, sin tope).
            </label>
            <div className="sim-rango-scroll">
            <div style={{ minWidth: 720 }}>
            <div style={{ ...st.rangoRow, gridTemplateColumns: '1fr 1fr 1fr 1fr auto', fontWeight: '600', color: '#6b7280', fontSize: 12 }}>
              <div>Valor mínimo</div><div>Valor máximo (vacío = sin tope)</div><div>{form.avaluo_tramos_tarifa_directa ? 'Tarifa directa' : 'Tarifa al millar'} (vacío = Se Cotiza)</div><div>Costo No Menor (vacío = Se Cotiza)</div><div></div>
            </div>
            {form.avaluo_tramos_millar.map((t, i) => (
              <div style={{ ...st.rangoRow, gridTemplateColumns: '1fr 1fr 1fr 1fr auto' }} key={i}>
                <input style={st.input} value={formatearMoneda(t.valor_minimo, 2)} onChange={(e) => cambiarTramoMillar(i, { valor_minimo: limpiarMoneda(e.target.value, 2) })} />
                <input style={st.input} value={formatearMoneda(t.valor_maximo, 2)} onChange={(e) => cambiarTramoMillar(i, { valor_maximo: limpiarMoneda(e.target.value, 2) })} placeholder="sin tope" />
                <input type="number" step="0.00001" min="0" style={st.input} value={t.tarifa_al_millar} onChange={(e) => cambiarTramoMillar(i, { tarifa_al_millar: e.target.value })} placeholder={form.avaluo_tramos_tarifa_directa ? 'Ej. 0.00250, vacío = Se Cotiza' : 'Ej. 2.50, vacío = Se Cotiza'} />
                <input style={st.input} value={formatearMoneda(t.costo_no_menor, 2)} onChange={(e) => cambiarTramoMillar(i, { costo_no_menor: limpiarMoneda(e.target.value, 2) })} placeholder="Se Cotiza" />
                <button type="button" style={st.btnDanger} onClick={() => quitarTramoMillar(i)}>Quitar</button>
              </div>
            ))}
            </div>
            </div>
            <button type="button" style={st.btnSecondary} onClick={agregarTramoMillar}>+ Agregar tramo</button>
            <div style={{ marginTop: 12 }}>
              <label style={st.checkLabel}>
                <input type="checkbox" checked={!!form.aplica_iva_avaluo} onChange={(e) => upd({ aplica_iva_avaluo: e.target.checked })} />
                ¿Aplica IVA (16%) sobre el costo de avalúo?
              </label>
            </div>
          </div>
        )}
      </div>

      {form.esquema_pago !== 'creciente' && (
        <div style={st.section}>
          <h4 style={st.sectionTitle}>Plazos autorizados</h4>
          <label style={st.label}>Vacío = sin restricción, cualquier plazo</label>
          <div style={st.plazosToolbar}>
            <button type="button" style={st.btnTiny} onClick={seleccionarTodosPlazos}>Seleccionar todos</button>
            <button type="button" style={st.btnTiny} onClick={quitarTodosPlazos}>Quitar todos</button>
          </div>
          <div style={st.checkboxGrid}>
            {ANIOS_PLAZO.map((anio) => (
              <label key={anio} style={st.checkLabel}>
                <input type="checkbox" checked={form.plazos_permitidos_meses.includes(anio * 12)} onChange={() => toggleAnioPlazo(anio)} />
                {anio} años
              </label>
            ))}
          </div>
        </div>
      )}

      <div style={st.section}>
        <h4 style={st.sectionTitle}>Escalones de reducción de tasa</h4>
        <label style={st.label}>Crédito de tasa variable, ej. Santander Free</label>
        <div className="sim-rango-scroll">
        <div style={{ minWidth: 420 }}>
        {form.ajustes.length > 0 && (
          <div style={{ ...st.rangoRow, gridTemplateColumns: '1fr 1fr auto', fontWeight: '600', color: '#6b7280', fontSize: 12 }}>
            <div>A partir del mes</div><div>Baja la tasa (puntos %)</div><div></div>
          </div>
        )}
        {form.ajustes.map((a, i) => (
          <div style={{ ...st.rangoRow, gridTemplateColumns: '1fr 1fr auto' }} key={i}>
            <input type="number" style={st.input} value={a.mes_desde} onChange={(e) => cambiarAjuste(i, { mes_desde: e.target.value })} placeholder="Ej. 37" />
            <input type="number" step="0.00000001" style={st.input} value={a.ajuste_pct} onChange={(e) => cambiarAjuste(i, { ajuste_pct: e.target.value })} placeholder="Ej. 0.15" />
            <button type="button" style={st.btnDanger} onClick={() => quitarAjuste(i)}>Quitar</button>
          </div>
        ))}
        </div>
        </div>
        <button type="button" style={st.btnSecondary} onClick={agregarAjuste}>+ Agregar escalón</button>
      </div>

      <div style={st.section}>
        <h4 style={st.sectionTitle}>Rangos de Aforo</h4>
        <label style={st.label}>Tasa según % del crédito respecto al valor del inmueble — vacío = usa la Tasa de interés anual fija de arriba</label>
        <div className="sim-rango-scroll">
        <div style={{ minWidth: 560 }}>
        {form.aforo_rangos.length > 0 && (
          <div style={{ ...st.rangoRow, fontWeight: '600', color: '#6b7280', fontSize: 12 }}>
            <div>% Aforo Mínimo</div><div>% Aforo Máximo (vacío = sin tope)</div><div>Tasa Anual (%)</div><div></div>
          </div>
        )}
        {form.aforo_rangos.map((a, i) => (
          <div style={st.rangoRow} key={i}>
            <input type="number" step="0.00000001" style={st.input} value={a.aforo_minimo} onChange={(e) => cambiarAforoRango(i, { aforo_minimo: e.target.value })} placeholder="Ej. 0" />
            <input type="number" step="0.00000001" style={st.input} value={a.aforo_maximo} onChange={(e) => cambiarAforoRango(i, { aforo_maximo: e.target.value })} placeholder="sin tope" />
            <input type="number" step="0.01" min="0" max="99.99" style={st.input} value={a.tasa_anual} onChange={(e) => cambiarAforoRango(i, { tasa_anual: e.target.value })} placeholder="Ej. 10.25" />
            <button type="button" style={st.btnDanger} onClick={() => quitarAforoRango(i)}>Quitar</button>
          </div>
        ))}
        </div>
        </div>
        <button type="button" style={st.btnSecondary} onClick={agregarAforoRango}>+ Agregar rango de Aforo</button>
      </div>

      <div style={st.section}>
        <h4 style={st.sectionTitle}>Tasas secundarias</h4>
        <label style={st.label}>La Tasa de interés anual capturada arriba sigue siendo la tasa menor/base. El asesor elige una de estas en el comparador cuando el banco no otorgó la mejor tasa. % Aforo Mínimo/Máximo vacíos = esta secundaria aplica sin importar el Aforo; si los capturas, solo aparece como opción cuando el Aforo del crédito cae en ese rango (ej. otra tasa secundaria si el Aforo es mayor a 80%).</label>
        <div className="sim-rango-scroll">
        <div style={{ minWidth: 720 }}>
        {form.secundarias.length > 0 && (
          <div style={{ ...st.rangoRow, gridTemplateColumns: '2fr 1fr 1fr 1fr auto', fontWeight: '600', color: '#6b7280', fontSize: 12 }}>
            <div>Etiqueta</div><div>Tasa %</div><div>% Aforo Mínimo</div><div>% Aforo Máximo</div><div></div>
          </div>
        )}
        {form.secundarias.map((s, i) => (
          <div style={{ ...st.rangoRow, gridTemplateColumns: '2fr 1fr 1fr 1fr auto' }} key={i}>
            <input style={st.input} value={s.etiqueta} onChange={(e) => cambiarSecundaria(i, { etiqueta: e.target.value })} placeholder="Ej. Tasa preferencial" />
            <input type="number" step="0.01" min="0" max="99.99" style={st.input} value={s.tasa_pct} onChange={(e) => cambiarSecundaria(i, { tasa_pct: e.target.value })} placeholder="Ej. 10.25" />
            <input type="number" step="0.00000001" style={st.input} value={s.aforo_minimo} onChange={(e) => cambiarSecundaria(i, { aforo_minimo: e.target.value })} placeholder="sin piso" />
            <input type="number" step="0.00000001" style={st.input} value={s.aforo_maximo} onChange={(e) => cambiarSecundaria(i, { aforo_maximo: e.target.value })} placeholder="sin tope" />
            <button type="button" style={st.btnDanger} onClick={() => quitarSecundaria(i)}>Quitar</button>
            <textarea
              style={{ ...st.textarea, gridColumn: '1 / -1' }}
              rows={2}
              maxLength={1000}
              value={s.condicionante || ''}
              onChange={(e) => cambiarSecundaria(i, { condicionante: e.target.value })}
              placeholder="Condicionante de esta tasa (opcional) — sale en la sección Notas del comparativo"
            />
            {form.esquema_pago === 'creciente' && (
              <div style={st.secCreciente}>
                <div style={st.secCrecienteTitulo}>Pago Creciente de esta tasa</div>
                {plazosBaseCreciente().length === 0 ? (
                  <div style={st.secCrecienteNota}>Primero agrega los plazos en "Plazos y % de Incremento Anual del Pago" (arriba).</div>
                ) : (
                  <>
                    <div style={{ ...st.rangoRow, gridTemplateColumns: '0.6fr 1fr 1.4fr', fontWeight: '600', color: '#6b7280', fontSize: 12 }}>
                      <div>Plazo</div><div>% Incremento Anual</div><div>Pago Mensual Inicial por c/$1,000,000 de crédito</div>
                    </div>
                    {plazosBaseCreciente().map((b) => {
                      const p = plazoSecundaria(s, b);
                      const falta = p.pago_inicial === '' || p.incremento_anual_pct === '';
                      return (
                        <React.Fragment key={b.meses}>
                          <div style={{ ...st.rangoRow, gridTemplateColumns: '0.6fr 1fr 1.4fr' }}>
                            <div style={{ fontSize: 13, color: '#111827' }}>{b.meses / 12} años</div>
                            <input type="number" step="0.01" min="0" max="99.99" style={st.input} value={p.incremento_anual_pct} onChange={(e) => cambiarPlazoSecundaria(i, b.meses, { incremento_anual_pct: e.target.value })} placeholder="Ej. 2.00" />
                            <input style={{ ...st.input, ...(falta ? st.inputFalta : {}) }} value={formatearMoneda(p.pago_inicial, 2)} onChange={(e) => cambiarPlazoSecundaria(i, b.meses, { pago_inicial: limpiarMoneda(e.target.value, 2) })} placeholder="Ej. 8,671.67" />
                          </div>
                          {falta && (
                            <div style={st.secCrecienteFalta}>
                              Falta capturar el Pago Mensual Inicial a {b.meses / 12} años: mientras falte, esta tasa no aparece en el comparador en ese plazo.
                            </div>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </>
                )}
              </div>
            )}
          </div>
        ))}
        </div>
        </div>
        <button type="button" style={st.btnSecondary} onClick={agregarSecundaria}>+ Agregar tasa secundaria</button>
      </div>

      <div style={st.section}>
        <h4 style={st.sectionTitle}>Condicionantes / Notas</h4>
        <label style={st.label}>Requisitos para acceder a esta hipoteca o a su tasa. Si la hipoteca/tasa se compara, el texto aparece en la sección "Notas" al final del comparativo (pantalla y PDF). Vacío = sin nota. La condicionante de cada tasa secundaria se captura en su renglón, arriba.</label>
        <label style={st.label}>Condicionante de la hipoteca (aplica a todas sus tasas)</label>
        <textarea
          style={st.textarea}
          rows={3}
          maxLength={1000}
          value={form.condicionante}
          onChange={(e) => upd({ condicionante: e.target.value })}
          placeholder="Opcional"
        />
        <label style={{ ...st.label, marginTop: 10 }}>Condicionante solo de la tasa base</label>
        <textarea
          style={st.textarea}
          rows={3}
          maxLength={1000}
          value={form.condicionante_tasa_base}
          onChange={(e) => upd({ condicionante_tasa_base: e.target.value })}
          placeholder="Opcional"
        />
      </div>

      <div style={st.section}>
        <h4 style={st.sectionTitle}>Tasa según Plazo Total</h4>
        <label style={st.checkLabel}>
          <input type="checkbox" checked={!!form.tasa_por_plazo_activo} onChange={(e) => upd({ tasa_por_plazo_activo: e.target.checked })} />
          Esta tasa depende del plazo total que el cliente elige al simular
        </label>
        <div style={{ marginTop: 4, marginBottom: 10 }}>
          <label style={st.label}>Se fija UNA sola tasa para todo el crédito según el plazo total solicitado (no cambia a la mitad, a diferencia de los tramos de tiempo transcurrido de Santander). No se combina con Rangos de Aforo ni con Escalones de reducción de tasa.</label>
        </div>
        {form.tasa_por_plazo_activo && (
          <>
            <div className="sim-rango-scroll">
            <div style={{ minWidth: 560 }}>
            {form.plazo_tasa_rangos.length > 0 && (
              <div style={{ ...st.rangoRow, fontWeight: '600', color: '#6b7280', fontSize: 12 }}>
                <div>Plazo Mínimo (años)</div><div>Plazo Máximo (años, vacío = sin tope)</div><div>Tasa %</div><div></div>
              </div>
            )}
            {form.plazo_tasa_rangos.map((p, i) => (
              <div style={st.rangoRow} key={i}>
                <input type="number" step="1" min="1" style={st.input} value={p.plazo_minimo_anios} onChange={(e) => cambiarPlazoTasaRango(i, { plazo_minimo_anios: e.target.value })} placeholder="Ej. 1" />
                <input type="number" step="1" min="1" style={st.input} value={p.plazo_maximo_anios} onChange={(e) => cambiarPlazoTasaRango(i, { plazo_maximo_anios: e.target.value })} placeholder="sin tope" />
                <input type="number" step="0.01" min="0" max="99.99" style={st.input} value={p.tasa_pct} onChange={(e) => cambiarPlazoTasaRango(i, { tasa_pct: e.target.value })} placeholder="Ej. 10.25" />
                <button type="button" style={st.btnDanger} onClick={() => quitarPlazoTasaRango(i)}>Quitar</button>
              </div>
            ))}
            </div>
            </div>
            <button type="button" style={st.btnSecondary} onClick={agregarPlazoTasaRango}>+ Agregar rango de plazo</button>
          </>
        )}
      </div>

      <div style={st.sectionLast}>
        <h4 style={st.sectionTitle}>Factor de mensualidad fija por plazo</h4>
        <label style={st.label}>% del monto del crédito, publicado por el banco — solo si la mensualidad no se calcula con la fórmula estándar de anualidad</label>
        <div className="sim-rango-scroll">
        <div style={{ minWidth: 420 }}>
        {form.factores.length > 0 && (
          <div style={{ ...st.rangoRow, gridTemplateColumns: '1fr 1fr auto', fontWeight: '600', color: '#6b7280', fontSize: 12 }}>
            <div>Plazo (años)</div><div>Factor mensual (%)</div><div></div>
          </div>
        )}
        {form.factores.map((f, i) => (
          <div style={{ ...st.rangoRow, gridTemplateColumns: '1fr 1fr auto' }} key={i}>
            <select style={st.select} value={f.plazo_meses} onChange={(e) => cambiarFactor(i, { plazo_meses: e.target.value })}>
              <option value="">Selecciona...</option>
              {ANIOS_PLAZO.map((anio) => <option key={anio} value={anio * 12}>{anio} años</option>)}
            </select>
            <input type="number" step="0.00000001" style={st.input} value={f.factor_pct} onChange={(e) => cambiarFactor(i, { factor_pct: e.target.value })} placeholder="Ej. 1.101" />
            <button type="button" style={st.btnDanger} onClick={() => quitarFactor(i)}>Quitar</button>
          </div>
        ))}
        </div>
        </div>
        <button type="button" style={st.btnSecondary} onClick={agregarFactor}>+ Agregar factor</button>
      </div>

      {error && <div style={st.error}>{error}</div>}
      <div style={st.actions}>
        <button type="button" style={st.btnSecondary} onClick={cancelar} disabled={guardando}>Cancelar</button>
        <button type="button" style={st.btnPrimary} onClick={guardar} disabled={guardando}>{guardando ? 'Guardando...' : 'Guardar'}</button>
      </div>
    </div>
  );

  const renderApoyoInfonavit = () => (
    <div style={st.card} className="sim-card">
      <h4 style={st.sectionTitle}>Tope de Apoyo Infonavit</h4>
      <label style={st.label}>
        Aportación bimestral en el comparador = Sueldo Bruto Mensual × % de sueldo × 2, topada a este monto. Actualízalo cada vez que suba (normalmente una vez al año).
      </label>
      <div style={st.grid3}>
        <div style={st.field}>
          <label style={st.label}>% de sueldo mensual</label>
          <input
            type="number" step="0.01" style={st.input}
            value={apoyoInfonavitForm.pct_sueldo_mensual}
            onChange={(e) => setApoyoInfonavitForm((f) => ({ ...f, pct_sueldo_mensual: e.target.value }))}
          />
        </div>
        <div style={st.field}>
          <label style={st.label}>Tope bimestral ($)</label>
          <input
            style={st.input}
            value={formatearMoneda(apoyoInfonavitForm.tope_bimestral, 2)}
            onChange={(e) => setApoyoInfonavitForm((f) => ({ ...f, tope_bimestral: limpiarMoneda(e.target.value, 2) }))}
          />
        </div>
      </div>
      {apoyoInfonavitError && <div style={st.error}>{apoyoInfonavitError}</div>}
      <div style={st.actions}>
        <button type="button" style={st.btnSecondary} onClick={cerrarApoyoInfonavit} disabled={apoyoInfonavitGuardando}>Cancelar</button>
        <button type="button" style={st.btnPrimary} onClick={guardarApoyoInfonavit} disabled={apoyoInfonavitGuardando}>
          {apoyoInfonavitGuardando ? 'Guardando...' : 'Guardar'}
        </button>
      </div>
    </div>
  );

  const tasasFiltradas = tasas.filter((t) => (
    (filtroBancos.length === 0 || filtroBancos.includes(t.banco))
    && (filtroTipos.length === 0 || filtroTipos.includes(t.aplica_tipo_inmueble))
    && (filtroEsquemas.length === 0 || filtroEsquemas.includes(esquemaDe(t)))
  ));

  return (
    <div style={st.wrap} className="sim-wrap">
      <div
        ref={headerRowRef}
        className="sim-header-row"
        style={{
          ...st.headerRow,
          position: 'sticky', top: 'var(--app-header-h, 120px)', zIndex: 31,
          backgroundColor: '#fff', paddingTop: 8, paddingBottom: 8,
        }}
      >
        <h3 style={st.title}>Tasas y Condiciones por Banco</h3>
        {editId === null && (
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button style={st.btnSecondary} onClick={abrirApoyoInfonavit}>Tope de Apoyo Infonavit</button>
            <button style={st.btnPrimary} onClick={abrirNuevo}>+ Nuevo Registro</button>
          </div>
        )}
      </div>

      {apoyoInfonavitAbierto && renderApoyoInfonavit()}

      {editId === null && tasas.length > 0 && (
        <div style={{ ...st.card, padding: 14, marginBottom: 12 }} className="sim-card">
          <div style={st.filtrosRow}>
            <DropdownCheckbox
              label="Tipo de Hipoteca"
              opciones={TIPOS_INMUEBLE.map((o) => ({ v: o.value, l: o.label }))}
              seleccion={filtroTipos}
              onToggle={toggleFiltroTipo}
              onClear={() => setFiltroTipos([])}
              ancho={210}
            />
            <DropdownCheckbox
              label="Banco"
              opciones={BANCOS.map((b) => ({ v: b, l: b }))}
              seleccion={filtroBancos}
              onToggle={toggleFiltroBanco}
              onClear={() => setFiltroBancos([])}
              ancho={190}
            />
            <DropdownCheckbox
              label="Esquema de Pago"
              opciones={ESQUEMAS_PAGO.map((o) => ({ v: o.value, l: o.label }))}
              seleccion={filtroEsquemas}
              onToggle={toggleFiltroEsquema}
              onClear={() => setFiltroEsquemas([])}
              ancho={160}
            />
          </div>
        </div>
      )}

      {editId !== null ? (
        renderForm()
      ) : cargando ? (
        <div style={st.empty}>Cargando...</div>
      ) : tasas.length === 0 ? (
        <div style={st.empty}>Aún no hay tasas capturadas. Usa "+ Nuevo Registro" para empezar.</div>
      ) : tasasFiltradas.length === 0 ? (
        <div style={st.empty}>Ningún registro coincide con el filtro seleccionado.</div>
      ) : (
        <table style={{ ...st.table, minWidth: 900 }}>
          <thead>
            <tr>
              {['Banco', 'Nombre de Hipoteca', 'Tipo de Hipoteca', 'Esquema de Pago', 'Tasa %', 'Comisión %', 'Aforo Máximo', 'Monto Máximo', ''].map((label) => (
                <th
                  key={label}
                  style={{
                    ...st.th,
                    position: 'sticky', top: `calc(var(--app-header-h, 120px) + ${headerRowH}px)`, zIndex: 30,
                  }}
                >
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tasasFiltradas.map((t) => (
              <tr key={t.id} style={!t.activo ? { opacity: 0.5 } : undefined}>
                <td style={st.td}>{t.banco}</td>
                <td style={st.td}>{t.tipo_credito}</td>
                <td style={st.td}>{(TIPOS_INMUEBLE.find((o) => o.value === t.aplica_tipo_inmueble) || {}).label || t.aplica_tipo_inmueble}</td>
                <td style={st.td}>{(ESQUEMAS_PAGO.find((o) => o.value === esquemaDe(t)) || {}).label}</td>
                <td style={st.td}>{t.tasa_anual}%</td>
                <td style={st.td}>{t.comision_apertura_pct}%</td>
                <td style={st.td}>{t.aforo_maximo_pct !== null && t.aforo_maximo_pct !== undefined ? `${t.aforo_maximo_pct}%` : 'Sin límite'}</td>
                <td style={st.td}>{t.monto_maximo_credito !== null && t.monto_maximo_credito !== undefined ? `$${formatearMoneda(t.monto_maximo_credito)}` : 'Sin límite'}</td>
                <td style={st.td}>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button style={st.btnSecondary} onClick={() => abrirEditar(t)}>Editar</button>
                    <button style={st.btnDanger} onClick={() => eliminar(t.id)}>Eliminar</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default SimuladorTasasCatalogo;
